<template>
  <div class="notifications">
    <v-container>
      <v-layout>
        <v-tabs>
          <v-tab to="/notifications" class="text-none"
            >Push Notifications
          </v-tab>
        </v-tabs>
      </v-layout>
      <v-divider />
      <router-view />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "PushNotifications",
  components: {},
};
</script>
